import React from 'react'

import SelectParentNew from "../../select-parent-new"
import {SelectParent_SectionType} from "../../@const"
import SelectParentsNew from "../../select-parents-new"
import SelectParent_Spaces from "./spaces"
import ProjectSelect_CompanyNoProjects from "./company-no-projects"
import {SpaceProto} from "../../../../model2/space/space-proto"
import SelectParent_CollapsableProjectsTree from "./right/projects-tree"
import {ProjectsTreeSortType} from "../../../../../layout/menu/components/space-preferences/preferences"
import {selectParent_recursiveUpdateExpandState} from "../../actions/filter"
import {selectParent_getProjects} from "../../actions/get-projects"
import Workspace from "../../../../model2/space/workspaces/workspace"
import {selectParent_getInitialCurrentSection} from "../../actions/get-initial-current-section"
import ProjectFinder from "../../../../gd-components/finder/project/project-finder"
import ProjectSession from "../../../../model2/project/project-session"
import {ItemDisplay} from "../../../../model2/item/item-model"
import SelectParent_AllProjects from "./right/all-projects"

type Props = {
    className?          : string
    parentSelector      : SelectParentNew | SelectParentsNew | ProjectFinder
    onParentSelected    : callback
}

type State = {
    searchString    : string
    currentSection? : SelectParent_SectionType | SpaceProto // ProjectSession - when workspace
}

// const debug = "SelectParent_Popover"
const debug = false

export default class SelectParent_Popover extends React.Component<Props, State> {

    public spaces       : SpaceProto[]

    public spacesToShow : SpaceProto[]
    public showStarred  : boolean
    public showPinned   : boolean

    constructor(props: Props) {
        super(props)

        this.spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

        this.spacesToShow   = this.spaces
        this.showStarred    = true
        this.showPinned     = true

        if (this.props.parentSelector.props.hideEmptySections) {
            this.spacesToShow = _.filter(this.spaces, (space:SpaceProto)=>{
                const projects = _.filter(selectParent_getProjects(space, {
                    availableProjects   : this.props.parentSelector.props.availableProjects,
                    parentsFor          : this.props.parentSelector.props.parentsFor
                }), (projectSession: ProjectSession) => {
                    return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
                })

                debug && console.log(debug, 'filter spaces', projects, space)

                return projects.length > 0
            })

            const starredProjects = _.filter(selectParent_getProjects(SelectParent_SectionType.STARRED, {
                availableProjects   : this.props.parentSelector.props.availableProjects,
                parentsFor          : this.props.parentSelector.props.parentsFor
            }), (projectSession: ProjectSession) => {
                return projectSession.treeDisplay === ItemDisplay.VISIBLE
            })

            debug && console.log(debug, 'filter starred', starredProjects)

            this.showStarred = starredProjects.length > 0

            const pinnedProjects = _.filter(selectParent_getProjects(SelectParent_SectionType.PINNED, {
                availableProjects   : this.props.parentSelector.props.availableProjects,
                parentsFor          : this.props.parentSelector.props.parentsFor
            }), (projectSession: ProjectSession) => {
                return projectSession.treeDisplay === ItemDisplay.VISIBLE
            })

            debug && console.log(debug, 'filter pinned', pinnedProjects)

            this.showPinned = pinnedProjects.length > 0
        }

        this.state = {
            currentSection  : selectParent_getInitialCurrentSection(this.props.parentSelector.selectedProjects, this.spacesToShow, !!this.props.parentSelector.props.unselectLabel),
            searchString    : "",
        }

        this._updateInitialExpand()
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    _updateInitialExpand() {

        // expand workspaces
        _.map(this.spaces, (space: SpaceProto) => {
            const project = (space as Workspace).project
            if (project) {
                project.treeIsExpandedProjectSelector = true
            }
        })

        // update initial expand state for each project
        selectParent_recursiveUpdateExpandState(
            this.state.currentSection,
            this.props.parentSelector.selectedProjects,
            this.props.parentSelector.props.availableProjects
        )
    }

    onSelectSection = (section: SelectParent_SectionType)=> {
        this.setState({
            currentSection: section
        })
    }

    onSelectWorkspace = (space?: SpaceProto)=> {
        this.setState({
            currentSection: space
        })
    }

    hidePopover = ()=>{
        this.props.parentSelector.hidePopover()
        this.setState({searchString: ""})
    }

    // search changed....
    onSearchChange = (searchString: string) => {
        // restore expanded projects if search string is empty
        if (!searchString) {
            this._updateInitialExpand()
        }

        this.setState({
            searchString: searchString
        })
    }

    render() {

        const parent = this.props.parentSelector
        const companyHasNoProjects = false // gd.session.projects.companyHasNoProjects


        const availableProjects = this.props.parentSelector.props.availableProjects || undefined

        let rightContent

        const currentSection = _.isEmpty(this.state.searchString) ? this.state.currentSection : SelectParent_SectionType.SEARCH
        const projects = selectParent_getProjects(currentSection, {
            availableProjects,
            searchString    : this.state.searchString,
            parentsFor      : this.props.parentSelector.props.parentsFor
        })

        if (currentSection) {
            switch (currentSection) {
                case SelectParent_SectionType.STARRED:
                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              colorized         = {true}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No starred items found."/>
                    )

                    break

                case SelectParent_SectionType.PINNED:

                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              colorized         = {true}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No pinned items found."/>
                    )

                    break


                case SelectParent_SectionType.SEARCH:
                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              colorized         = {true}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No projects found."
                                                              applyTreeDisplay  = {true}/>
                    )

                    break

                default:
                    const space = currentSection as SpaceProto

                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              colorized         = {true}
                                                              sortType          = {space.projectsSorting}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No projects found."/>
                    )
            }
        } else {
            rightContent = <SelectParent_AllProjects/>
        }

        return (
            <>
                {companyHasNoProjects &&
                    <ProjectSelect_CompanyNoProjects parent={this.props.parentSelector}/>}

                {!companyHasNoProjects &&
                    <div className="flex-row-left-top h-350">
                        <SelectParent_Spaces parent={this}/>

                        <div className="flex-column-right-top w-300 h-100-percent">
                            {rightContent}
                        </div>
                    </div>}
            </>
        )
    }
}
